(function () {
    'use strict';

    angular
        .module('app')
        .controller('LoginStatsController', LoginStatsController);

     LoginStatsController.$inject = ['authentication','$window','moment'];

     function LoginStatsController (authentication,$window,moment) {
         var vm = this;

         vm.isLoading = true;
         vm.isAfwpAdmin = false;
         vm.isDataLoaded = false;
         vm.loginCount = {};
         vm.loginCount.services = {};
         vm.currentDate = new Date();
         vm.startDate = moment().subtract(6, 'months').toISOString();
         vm.endDate = new Date().toISOString();
         vm.decodeUrl = decodeUrl;
         vm.onClickSearch = onClickSearch;


         activate();

         function activate() {
             authentication.getUserProfile().then(function(userInfo) {
                 for (var i = 0; i < userInfo.aosUser.aosRoles.length; i++) {
                     if (userInfo.aosUser.aosRoles[i] === "AFWP Administrator") {
                         vm.isAfwpAdmin = true;
                     }
                 }
                 // if(vm.isAfwpAdmin){
                 //     authentication.getLoginStats("2023-08-01").then(function(loginStats){
                 //         vm.loginCount = loginStats;
                 //     });
                 // }
                 vm.isLoading = false;
             });
         }

         function decodeUrl(url) {
             return $window.decodeURIComponent(url);
         }

         function onClickSearch(startDate,endDate) {
             vm.isLoading = true;
             if(vm.isAfwpAdmin){
                 authentication.getLoginStats(startDate,endDate).then(function(loginStats){
                     vm.loginCount = loginStats;
                 });
             }
             vm.isDataLoaded = true;
             vm.isLoading = false;
         }
     }

})();